import {
    DESTROY_TOKEN,
    FORGOT_PASSWORD,
    GET_OAUTH_SERVICES,
    LOGIN,
    LOGOUT,
    OAUTH_CALLBACK,
    RESET_PASSWORD,
    RESET_PASSWORD_CHECK_TOKEN,
    SET_ACCESS_TOKEN,
    SET_OAUTH_SERVICES,
    TWO_FACTOR_AUTHENTICATION,
    TWO_FACTOR_AUTHENTICATION_CHECK_TOKEN
} from "@/core/store/modules/auth/constants";
import api from "@/core/services/api/api.service"
import {DESTROY_ACCOUNT, SET_ACCOUNT} from "@/core/store/modules/account/constants";
import {REFRESH_CAPTCHA} from "@/core/store/modules/captcha/constants";
export default {
    [LOGIN](context, credentials) {
        return new Promise((resolve, reject) => {
            api.waiting('login').post(`${process.env.VUE_APP_API_COMMON_URL}/login`, credentials)
                .then((response) => {
                    if (response.data.success) {
                        if (!response.data.two_factor_authentication) {
                            context.commit(SET_ACCESS_TOKEN, response.data.access_token);
                            context.commit(SET_ACCOUNT, response.data.account);
                        }
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
                .catch((error) => {
                    context.dispatch(REFRESH_CAPTCHA)
                    reject(error)
                })
        })
    },

    [FORGOT_PASSWORD](context, data) {
        return new Promise((resolve, reject) => {
            api.waiting('forgot-password').post(`${process.env.VUE_APP_API_COMMON_URL}/forgot-password`, data)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    context.dispatch(REFRESH_CAPTCHA)
                    reject(error)
                })

        })
    },

    [RESET_PASSWORD_CHECK_TOKEN](context, data) {
        return new Promise((resolve, reject) => {
            api.waiting('reset-password').post(`${process.env.VUE_APP_API_COMMON_URL}/reset-password/check-token`, data)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    [RESET_PASSWORD](context, data) {
        return new Promise((resolve, reject) => {
            api.waiting('reset-password').post(`${process.env.VUE_APP_API_COMMON_URL}/reset-password/confirm`, data)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    context.dispatch(REFRESH_CAPTCHA)
                    reject(error)
                })

        })
    },

    [LOGOUT](context) {
        if (context.getters.isAuthenticated) {
            // pusher.disconnect()
            return new Promise((resolve, reject) => {
                api.waiting('logout').post(`${process.env.VUE_APP_API_COMMON_URL}/logout`)
                    .then((response) => {
                        context.commit(DESTROY_TOKEN);
                        context.commit(DESTROY_ACCOUNT);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.commit(DESTROY_TOKEN);
                        context.commit(DESTROY_ACCOUNT);
                        reject(error)
                    })
            })
        }
    },

    [GET_OAUTH_SERVICES](context) {
        if (!context.state.oauthServicesBooted) {
            api.get(`${process.env.VUE_APP_API_COMMON_URL}/oauth/services`)
                .then(response => {
                    context.commit(SET_OAUTH_SERVICES, response.data.services)
                })
                .catch(error => {
                })
        }
    },

    [OAUTH_CALLBACK](context, data) {
        return new Promise((resolve, reject) => {
            api.post(`${process.env.VUE_APP_API_COMMON_URL}/oauth/${data.provider}/callback`, null, {
                params: data.query
            })
                .then((response) => {
                    if (response.data.success) {
                        if (!response.data.two_factor_authentication) {
                            context.commit(SET_ACCESS_TOKEN, response.data.access_token);
                            context.commit(SET_ACCOUNT, response.data.account);
                        }
                        resolve(response)
                    }
                    reject(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    [TWO_FACTOR_AUTHENTICATION_CHECK_TOKEN](context, data) {
        return new Promise((resolve, reject) => {
            api.waiting('two-factor-authentication')
                .post(`${process.env.VUE_APP_API_COMMON_URL}/2fa/check-token`, data)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    [TWO_FACTOR_AUTHENTICATION](context, data) {
        return new Promise((resolve, reject) => {
            api.waiting('two-factor-authentication')
                .post(`${process.env.VUE_APP_API_COMMON_URL}/2fa/confirm`, data)
                .then((response) => {
                    if (response.data.success) {
                        context.commit(SET_ACCESS_TOKEN, response.data.access_token);
                        context.commit(SET_ACCOUNT, response.data.account);
                    }
                    resolve(response)
                })
                .catch((error) => {
                    context.dispatch(REFRESH_CAPTCHA)
                    reject(error)
                })

        })
    },

}